// tslint:disable
/**
 * Bff for Frontend API
 * project to provide a backend api for frontend
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

type AnyType = any;

/**
 *
 * @export
 * @interface Area
 */
export interface Area {
    /**
     *
     * @type {number}
     * @memberof Area
     */
    id: number;
    /**
     *
     * @type {string}
     * @memberof Area
     */
    localName: string;
    /**
     *
     * @type {string}
     * @memberof Area
     */
    normalizedName: string;
    /**
     *
     * @type {number}
     * @memberof Area
     */
    parentAreaId: number | null;
    /**
     *
     * @type {Area & AnyType}
     * @memberof Area
     */
    parentArea: Area & AnyType;
}
/**
 *
 * @export
 * @interface AreasSuggestionResponse
 */
export interface AreasSuggestionResponse {
    /**
     *
     * @type {Array<ExploreArea>}
     * @memberof AreasSuggestionResponse
     */
    areas: Array<ExploreArea>;
    /**
     *
     * @type {Array<ExploreStation>}
     * @memberof AreasSuggestionResponse
     */
    stations: Array<ExploreStation>;
}
/**
 *
 * @export
 * @interface AvailableResponse
 */
export interface AvailableResponse {
    /**
     *
     * @type {boolean}
     * @memberof AvailableResponse
     */
    isAvailable: boolean;
}
/**
 *
 * @export
 * @interface BlogPost
 */
export interface BlogPost {
    /**
     *
     * @type {number}
     * @memberof BlogPost
     */
    publicId: number;
    /**
     *
     * @type {string}
     * @memberof BlogPost
     */
    name: string;
    /**
     *
     * @type {string}
     * @memberof BlogPost
     */
    description: string;
    /**
     *
     * @type {string}
     * @memberof BlogPost
     */
    jsonDescription: string;
    /**
     *
     * @type {ThumbnailImage}
     * @memberof BlogPost
     */
    primaryImage: ThumbnailImage;
    /**
     *
     * @type {string}
     * @memberof BlogPost
     */
    publishedAt: string;
}
/**
 *
 * @export
 * @interface BookingService
 */
export interface BookingService {
    /**
     *
     * @type {boolean}
     * @memberof BookingService
     */
    isPasswordProtected: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BookingService
     */
    isPublishedWithPasswordProtected: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BookingService
     */
    isTimeSlotVacancyVisible: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BookingService
     */
    isWaitingListProvided: boolean;
    /**
     *
     * @type {string}
     * @memberof BookingService
     */
    jsonDescription: string;
    /**
     *
     * @type {string}
     * @memberof BookingService
     */
    name: string;
    /**
     *
     * @type {number}
     * @memberof BookingService
     */
    publicId: number;
    /**
     *
     * @type {BookingServiceSetting}
     * @memberof BookingService
     */
    setting: BookingServiceSetting;
    /**
     *
     * @type {number}
     * @memberof BookingService
     */
    scheme: number;
    /**
     *
     * @type {number}
     * @memberof BookingService
     */
    initialSettingStatus: number;
    /**
     *
     * @type {number}
     * @memberof BookingService
     */
    coverContentsType: number;
    /**
     *
     * @type {string}
     * @memberof BookingService
     */
    description: string;
    /**
     *
     * @type {string}
     * @memberof BookingService
     */
    publishedAt: string;
    /**
     *
     * @type {number}
     * @memberof BookingService
     */
    lowestPrice: number;
    /**
     *
     * @type {Array<string>}
     * @memberof BookingService
     */
    tagNames: Array<string>;
    /**
     *
     * @type {CoverContent}
     * @memberof BookingService
     */
    coverContent: CoverContent;
    /**
     *
     * @type {BookingServiceThumbnailImage}
     * @memberof BookingService
     */
    primaryImage: BookingServiceThumbnailImage;
    /**
     *
     * @type {boolean}
     * @memberof BookingService
     */
    isFullyBooked: boolean;
    /**
     *
     * @type {Array<BookingServiceThumbnailImage>}
     * @memberof BookingService
     */
    secondaryImages: Array<BookingServiceThumbnailImage>;
    /**
     *
     * @type {ZoomSetting}
     * @memberof BookingService
     */
    zoomSetting: ZoomSetting;
}
/**
 *
 * @export
 * @interface BookingServiceCalenderDate
 */
export interface BookingServiceCalenderDate {
    /**
     *
     * @type {string}
     * @memberof BookingServiceCalenderDate
     */
    date: string;
    /**
     *
     * @type {Array<BookingServiceCalenderItem>}
     * @memberof BookingServiceCalenderDate
     */
    items: Array<BookingServiceCalenderItem>;
}
/**
 *
 * @export
 * @interface BookingServiceCalenderItem
 */
export interface BookingServiceCalenderItem {
    /**
     *
     * @type {BookingService}
     * @memberof BookingServiceCalenderItem
     */
    service: BookingService;
    /**
     *
     * @type {Lesson}
     * @memberof BookingServiceCalenderItem
     */
    lesson: Lesson;
    /**
     *
     * @type {TimeSlot}
     * @memberof BookingServiceCalenderItem
     */
    slot: TimeSlot;
    /**
     *
     * @type {boolean}
     * @memberof BookingServiceCalenderItem
     */
    isAllDay: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BookingServiceCalenderItem
     */
    isInTerm: boolean;
    /**
     *
     * @type {string}
     * @memberof BookingServiceCalenderItem
     */
    bookingUrl: string;
    /**
     *
     * @type {string}
     * @memberof BookingServiceCalenderItem
     */
    color: string;
    /**
     *
     * @type {BookingServiceCalenderTitle}
     * @memberof BookingServiceCalenderItem
     */
    title: BookingServiceCalenderTitle;
    /**
     *
     * @type {string}
     * @memberof BookingServiceCalenderItem
     */
    startAt: string;
    /**
     *
     * @type {boolean}
     * @memberof BookingServiceCalenderItem
     */
    isFull: boolean;
    /**
     *
     * @type {string}
     * @memberof BookingServiceCalenderItem
     */
    digest: string;
}
/**
 *
 * @export
 * @interface BookingServiceCalenderTitle
 */
export interface BookingServiceCalenderTitle {
    /**
     *
     * @type {number}
     * @memberof BookingServiceCalenderTitle
     */
    type: number;
    /**
     *
     * @type {string}
     * @memberof BookingServiceCalenderTitle
     */
    title: string;
    /**
     *
     * @type {number}
     * @memberof BookingServiceCalenderTitle
     */
    vacancy: number;
}
/**
 *
 * @export
 * @interface BookingServiceSetting
 */
export interface BookingServiceSetting {
    /**
     *
     * @type {boolean}
     * @memberof BookingServiceSetting
     */
    isPrepayable: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BookingServiceSetting
     */
    isPayableOnSite: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BookingServiceSetting
     */
    isPayableWithSubscription: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BookingServiceSetting
     */
    isPayableWithTicket: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BookingServiceSetting
     */
    isStaffSelectable: boolean;
}
/**
 *
 * @export
 * @interface BookingServiceThumbnailImage
 */
export interface BookingServiceThumbnailImage {
    /**
     *
     * @type {ThumbnailOriginalImageScheme}
     * @memberof BookingServiceThumbnailImage
     */
    original: ThumbnailOriginalImageScheme;
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof BookingServiceThumbnailImage
     */
    square: ThumbnailImageScheme;
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof BookingServiceThumbnailImage
     */
    c800x420: ThumbnailImageScheme;
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof BookingServiceThumbnailImage
     */
    p800x600: ThumbnailImageScheme;
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof BookingServiceThumbnailImage
     */
    w1280: ThumbnailImageScheme;
}
/**
 *
 * @export
 * @interface BusinessHour
 */
export interface BusinessHour {
    /**
     *
     * @type {string}
     * @memberof BusinessHour
     */
    closingHour: string;
    /**
     *
     * @type {boolean}
     * @memberof BusinessHour
     */
    isOpen: boolean;
    /**
     *
     * @type {string}
     * @memberof BusinessHour
     */
    openingHour: string;
    /**
     *
     * @type {number}
     * @memberof BusinessHour
     */
    weekday: number;
}
/**
 *
 * @export
 * @interface CancelableRegulation
 */
export interface CancelableRegulation {
    /**
     *
     * @type {string}
     * @memberof CancelableRegulation
     */
    type: string;
    /**
     *
     * @type {number}
     * @memberof CancelableRegulation
     */
    until: number;
    /**
     *
     * @type {boolean}
     * @memberof CancelableRegulation
     */
    prepayable: boolean;
    /**
     *
     * @type {number}
     * @memberof CancelableRegulation
     */
    refundableDaysLimit: number;
}
/**
 *
 * @export
 * @interface ChangeableRegulation
 */
export interface ChangeableRegulation {
    /**
     *
     * @type {string}
     * @memberof ChangeableRegulation
     */
    type: string;
    /**
     *
     * @type {number}
     * @memberof ChangeableRegulation
     */
    until: number;
}
/**
 *
 * @export
 * @interface Course
 */
export interface Course {
    /**
     *
     * @type {number}
     * @memberof Course
     */
    id: number;
    /**
     *
     * @type {number}
     * @memberof Course
     */
    publicId: number;
    /**
     *
     * @type {number}
     * @memberof Course
     */
    duration: number;
    /**
     *
     * @type {number}
     * @memberof Course
     */
    blockingDuration: number;
    /**
     *
     * @type {number}
     * @memberof Course
     */
    price: number;
    /**
     *
     * @type {number}
     * @memberof Course
     */
    onsitePrice: number;
    /**
     *
     * @type {string}
     * @memberof Course
     */
    name: string;
    /**
     *
     * @type {ThumbnailImage}
     * @memberof Course
     */
    image: ThumbnailImage;
    /**
     *
     * @type {string}
     * @memberof Course
     */
    description: string;
}
/**
 *
 * @export
 * @interface CoverContent
 */
export interface CoverContent {
    /**
     *
     * @type {string}
     * @memberof CoverContent
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof CoverContent
     */
    embed: string;
    /**
     *
     * @type {ThumbnailImage}
     * @memberof CoverContent
     */
    image: ThumbnailImage;
}
/**
 *
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     *
     * @type {number}
     * @memberof ErrorResponse
     */
    statusCode: number;
    /**
     *
     * @type {string}
     * @memberof ErrorResponse
     */
    exceptionName: string;
    /**
     *
     * @type {string}
     * @memberof ErrorResponse
     */
    message: string;
    /**
     *
     * @type {string}
     * @memberof ErrorResponse
     */
    timestamp: string;
    /**
     *
     * @type {object}
     * @memberof ErrorResponse
     */
    detail: object;
}
/**
 *
 * @export
 * @interface ExploreArea
 */
export interface ExploreArea {
    /**
     *
     * @type {MerchantCategory}
     * @memberof ExploreArea
     */
    merchantCategory: MerchantCategory;
    /**
     *
     * @type {Area}
     * @memberof ExploreArea
     */
    area: Area;
    /**
     *
     * @type {number}
     * @memberof ExploreArea
     */
    merchantCount: number;
}
/**
 *
 * @export
 * @interface ExploreCategoryAreaResponse
 */
export interface ExploreCategoryAreaResponse {
    /**
     *
     * @type {ExploreArea}
     * @memberof ExploreCategoryAreaResponse
     */
    exploreArea: ExploreArea;
    /**
     *
     * @type {Array<ExploreMerchant>}
     * @memberof ExploreCategoryAreaResponse
     */
    exploerMerchants: Array<ExploreMerchant>;
    /**
     *
     * @type {Pagination}
     * @memberof ExploreCategoryAreaResponse
     */
    pagination: Pagination;
}
/**
 *
 * @export
 * @interface ExploreCategoryResponse
 */
export interface ExploreCategoryResponse {
    /**
     *
     * @type {MerchantCategory}
     * @memberof ExploreCategoryResponse
     */
    merchantCategory: MerchantCategory;
    /**
     *
     * @type {Array<ExploreMerchant>}
     * @memberof ExploreCategoryResponse
     */
    exploerMerchants: Array<ExploreMerchant>;
    /**
     *
     * @type {Pagination}
     * @memberof ExploreCategoryResponse
     */
    pagination: Pagination;
}
/**
 *
 * @export
 * @interface ExploreCategoryStationResponse
 */
export interface ExploreCategoryStationResponse {
    /**
     *
     * @type {ExploreStation}
     * @memberof ExploreCategoryStationResponse
     */
    exploreStation: ExploreStation;
    /**
     *
     * @type {Array<ExploreMerchant>}
     * @memberof ExploreCategoryStationResponse
     */
    exploerMerchants: Array<ExploreMerchant>;
    /**
     *
     * @type {Pagination}
     * @memberof ExploreCategoryStationResponse
     */
    pagination: Pagination;
    /**
     *
     * @type {Area}
     * @memberof ExploreCategoryStationResponse
     */
    area: Area;
}
/**
 *
 * @export
 * @interface ExploreMerchant
 */
export interface ExploreMerchant {
    /**
     *
     * @type {Merchant}
     * @memberof ExploreMerchant
     */
    merchant: Merchant;
    /**
     *
     * @type {Area}
     * @memberof ExploreMerchant
     */
    area: Area;
    /**
     *
     * @type {Array<MerchantStation>}
     * @memberof ExploreMerchant
     */
    merchantStations: Array<MerchantStation>;
}
/**
 *
 * @export
 * @interface ExploreStation
 */
export interface ExploreStation {
    /**
     *
     * @type {MerchantCategory}
     * @memberof ExploreStation
     */
    merchantCategory: MerchantCategory;
    /**
     *
     * @type {Station}
     * @memberof ExploreStation
     */
    station: Station;
    /**
     *
     * @type {number}
     * @memberof ExploreStation
     */
    merchantCount: number;
}
/**
 *
 * @export
 * @interface ExploreTopContentResponse
 */
export interface ExploreTopContentResponse {
    /**
     *
     * @type {Array<ExploreMerchant>}
     * @memberof ExploreTopContentResponse
     */
    newMerchants: Array<ExploreMerchant>;
    /**
     *
     * @type {Array<ExploreMerchant>}
     * @memberof ExploreTopContentResponse
     */
    popularMerchants: Array<ExploreMerchant>;
    /**
     *
     * @type {Array<ExploreMerchant>}
     * @memberof ExploreTopContentResponse
     */
    recentlyBookedMerchants: Array<ExploreMerchant>;
    /**
     *
     * @type {Array<MerchantCategory>}
     * @memberof ExploreTopContentResponse
     */
    primaryCategories: Array<MerchantCategory>;
}
/**
 *
 * @export
 * @interface Lesson
 */
export interface Lesson {
    /**
     *
     * @type {number}
     * @memberof Lesson
     */
    id: number;
    /**
     *
     * @type {number}
     * @memberof Lesson
     */
    canonicalId: number;
    /**
     *
     * @type {number}
     * @memberof Lesson
     */
    bookingServiceId: number;
    /**
     *
     * @type {string}
     * @memberof Lesson
     */
    name: string;
    /**
     *
     * @type {string}
     * @memberof Lesson
     */
    description: string;
    /**
     *
     * @type {string}
     * @memberof Lesson
     */
    startDate: string;
    /**
     *
     * @type {string}
     * @memberof Lesson
     */
    endDate: string;
    /**
     *
     * @type {number}
     * @memberof Lesson
     */
    sortOrder: number;
}
/**
 *
 * @export
 * @interface Line
 */
export interface Line {
    /**
     *
     * @type {number}
     * @memberof Line
     */
    id: number;
    /**
     *
     * @type {number}
     * @memberof Line
     */
    originalLineId: number;
    /**
     *
     * @type {string}
     * @memberof Line
     */
    name: string;
}
/**
 *
 * @export
 * @interface MapWidget
 */
export interface MapWidget {
    /**
     *
     * @type {string}
     * @memberof MapWidget
     */
    addressCity: string;
    /**
     *
     * @type {string}
     * @memberof MapWidget
     */
    href: string;
    /**
     *
     * @type {string}
     * @memberof MapWidget
     */
    imgSource: string;
    /**
     *
     * @type {number}
     * @memberof MapWidget
     */
    latitude: number;
    /**
     *
     * @type {number}
     * @memberof MapWidget
     */
    longitude: number;
}
/**
 *
 * @export
 * @interface Merchant
 */
export interface Merchant {
    /**
     *
     * @type {string}
     * @memberof Merchant
     */
    address: string;
    /**
     *
     * @type {number}
     * @memberof Merchant
     */
    areaId: number | null;
    /**
     *
     * @type {Area & AnyType}
     * @memberof Merchant
     */
    area: Area & AnyType;
    /**
     *
     * @type {Array<BusinessHour>}
     * @memberof Merchant
     */
    businessHours: Array<BusinessHour>;
    /**
     *
     * @type {MerchantCoverImage}
     * @memberof Merchant
     */
    coverImage: MerchantCoverImage;
    /**
     *
     * @type {string}
     * @memberof Merchant
     */
    createdAt: string;
    /**
     *
     * @type {string}
     * @memberof Merchant
     */
    deletedAt: string | null;
    /**
     *
     * @type {string}
     * @memberof Merchant
     */
    description: string;
    /**
     *
     * @type {string}
     * @memberof Merchant
     */
    displayName: string;
    /**
     *
     * @type {number}
     * @memberof Merchant
     */
    favoriteCount: number;
    /**
     *
     * @type {MerchantFeature}
     * @memberof Merchant
     */
    feature: MerchantFeature;
    /**
     *
     * @type {string}
     * @memberof Merchant
     */
    locale: MerchantLocaleEnum;
    /**
     *
     * @type {number}
     * @memberof Merchant
     */
    merchantCategoryId: number;
    /**
     *
     * @type {Array<MerchantStation>}
     * @memberof Merchant
     */
    merchantStations: Array<MerchantStation>;
    /**
     *
     * @type {MerchantMetaSetting}
     * @memberof Merchant
     */
    metaSetting: MerchantMetaSetting;
    /**
     *
     * @type {string}
     * @memberof Merchant
     */
    phoneNumber: string;
    /**
     *
     * @type {string}
     * @memberof Merchant
     */
    publicId: string;
    /**
     *
     * @type {MerchantRating}
     * @memberof Merchant
     */
    rating: MerchantRating;
    /**
     *
     * @type {MerchantSetting}
     * @memberof Merchant
     */
    setting: MerchantSetting;
    /**
     *
     * @type {Array<MerchantImageGallery>}
     * @memberof Merchant
     */
    gallery: Array<MerchantImageGallery>;
    /**
     *
     * @type {MerchantThumbnailImage}
     * @memberof Merchant
     */
    thumbnailImage: MerchantThumbnailImage;
    /**
     *
     * @type {string}
     * @memberof Merchant
     */
    updatedAt: string;
    /**
     *
     * @type {string}
     * @memberof Merchant
     */
    timeZone: string;
}

/**
    * @export
    * @enum {string}
    */
export enum MerchantLocaleEnum {
    Ja = 'ja',
    En = 'en',
    Ko = 'ko'
}

/**
 *
 * @export
 * @interface MerchantCategory
 */
export interface MerchantCategory {
    /**
     *
     * @type {number}
     * @memberof MerchantCategory
     */
    id: number;
    /**
     *
     * @type {string}
     * @memberof MerchantCategory
     */
    nameJA: string;
    /**
     *
     * @type {string}
     * @memberof MerchantCategory
     */
    nameEN: string;
    /**
     *
     * @type {string}
     * @memberof MerchantCategory
     */
    nameKO: string;
    /**
     *
     * @type {number}
     * @memberof MerchantCategory
     */
    displayOrder: number;
    /**
     *
     * @type {string}
     * @memberof MerchantCategory
     */
    imageUrl: string;
}
/**
 *
 * @export
 * @interface MerchantCoverImage
 */
export interface MerchantCoverImage {
    /**
     *
     * @type {string}
     * @memberof MerchantCoverImage
     */
    fileName: string;
    /**
     *
     * @type {string}
     * @memberof MerchantCoverImage
     */
    url: string;
}
/**
 *
 * @export
 * @interface MerchantFeature
 */
export interface MerchantFeature {
    /**
     *
     * @type {boolean}
     * @memberof MerchantFeature
     */
    isAdHiding: boolean;
}
/**
 *
 * @export
 * @interface MerchantImageGallery
 */
export interface MerchantImageGallery {
    /**
     *
     * @type {number}
     * @memberof MerchantImageGallery
     */
    id: number;
    /**
     *
     * @type {string}
     * @memberof MerchantImageGallery
     */
    mainUrl: string;
    /**
     *
     * @type {string}
     * @memberof MerchantImageGallery
     */
    thumbnailUrl: string;
}
/**
 *
 * @export
 * @interface MerchantMetaSetting
 */
export interface MerchantMetaSetting {
    /**
     *
     * @type {string}
     * @memberof MerchantMetaSetting
     */
    title: string;
    /**
     *
     * @type {boolean}
     * @memberof MerchantMetaSetting
     */
    isNoIndex: boolean;
    /**
     *
     * @type {string}
     * @memberof MerchantMetaSetting
     */
    keyword: string;
    /**
     *
     * @type {string}
     * @memberof MerchantMetaSetting
     */
    description: string;
}
/**
 *
 * @export
 * @interface MerchantRating
 */
export interface MerchantRating {
    /**
     *
     * @type {number}
     * @memberof MerchantRating
     */
    average: number;
    /**
     *
     * @type {MerchantRatingPoint}
     * @memberof MerchantRating
     */
    points: MerchantRatingPoint;
    /**
     *
     * @type {number}
     * @memberof MerchantRating
     */
    sum: number;
    /**
     *
     * @type {number}
     * @memberof MerchantRating
     */
    totalCount: number;
}
/**
 *
 * @export
 * @interface MerchantRatingPoint
 */
export interface MerchantRatingPoint {
    /**
     *
     * @type {number}
     * @memberof MerchantRatingPoint
     */
    one: number;
    /**
     *
     * @type {number}
     * @memberof MerchantRatingPoint
     */
    two: number;
    /**
     *
     * @type {number}
     * @memberof MerchantRatingPoint
     */
    three: number;
    /**
     *
     * @type {number}
     * @memberof MerchantRatingPoint
     */
    four: number;
    /**
     *
     * @type {number}
     * @memberof MerchantRatingPoint
     */
    five: number;
}
/**
 *
 * @export
 * @interface MerchantSetting
 */
export interface MerchantSetting {
    /**
     *
     * @type {boolean}
     * @memberof MerchantSetting
     */
    isCourseDurationVisible: boolean;
    /**
     *
     * @type {boolean}
     * @memberof MerchantSetting
     */
    isCustomerReviewActive: boolean;
    /**
     *
     * @type {boolean}
     * @memberof MerchantSetting
     */
    isNoindex: boolean;
    /**
     *
     * @type {boolean}
     * @memberof MerchantSetting
     */
    isPastTimeSlotsVisible: boolean;
    /**
     *
     * @type {boolean}
     * @memberof MerchantSetting
     */
    isExploreOnly: boolean;
    /**
     *
     * @type {string}
     * @memberof MerchantSetting
     */
    exploreOnlyMerchantReservationPageUrl: string;
    /**
     *
     * @type {string}
     * @memberof MerchantSetting
     */
    contactUrl: string;
    /**
     *
     * @type {boolean}
     * @memberof MerchantSetting
     */
    isOnsitePaymentToBankTransferLabel: boolean;
}
/**
 *
 * @export
 * @interface MerchantStation
 */
export interface MerchantStation {
    /**
     *
     * @type {string}
     * @memberof MerchantStation
     */
    name: string;
    /**
     *
     * @type {number}
     * @memberof MerchantStation
     */
    originalStationId: number;
    /**
     *
     * @type {number}
     * @memberof MerchantStation
     */
    distance: number;
    /**
     *
     * @type {number}
     * @memberof MerchantStation
     */
    walkingTime: number;
}
/**
 *
 * @export
 * @interface MerchantThumbnailImage
 */
export interface MerchantThumbnailImage {
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof MerchantThumbnailImage
     */
    original: ThumbnailImageScheme;
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof MerchantThumbnailImage
     */
    w120: ThumbnailImageScheme;
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof MerchantThumbnailImage
     */
    w300: ThumbnailImageScheme;
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof MerchantThumbnailImage
     */
    w1280: ThumbnailImageScheme;
}
/**
 *
 * @export
 * @interface MultiAreaResponse
 */
export interface MultiAreaResponse {
    /**
     *
     * @type {Array<Area>}
     * @memberof MultiAreaResponse
     */
    areas: Array<Area>;
}
/**
 *
 * @export
 * @interface MultiExploreAreaResponse
 */
export interface MultiExploreAreaResponse {
    /**
     *
     * @type {Array<ExploreArea>}
     * @memberof MultiExploreAreaResponse
     */
    exploreAreas: Array<ExploreArea>;
}
/**
 *
 * @export
 * @interface MultiExploreStationResponse
 */
export interface MultiExploreStationResponse {
    /**
     *
     * @type {Array<ExploreStation>}
     * @memberof MultiExploreStationResponse
     */
    exploreStations: Array<ExploreStation>;
}
/**
 *
 * @export
 * @interface MultiMerchantCategoryResponse
 */
export interface MultiMerchantCategoryResponse {
    /**
     *
     * @type {Array<MerchantCategory>}
     * @memberof MultiMerchantCategoryResponse
     */
    merchantCategories: Array<MerchantCategory>;
}
/**
 *
 * @export
 * @interface MultiMerchantResponse
 */
export interface MultiMerchantResponse {
    /**
     *
     * @type {Array<Merchant>}
     * @memberof MultiMerchantResponse
     */
    merchants: Array<Merchant>;
    /**
     *
     * @type {Pagination}
     * @memberof MultiMerchantResponse
     */
    pagination: Pagination;
}
/**
 *
 * @export
 * @interface MultiStationResponse
 */
export interface MultiStationResponse {
    /**
     *
     * @type {Array<Station>}
     * @memberof MultiStationResponse
     */
    stations: Array<Station>;
}
/**
 *
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     *
     * @type {number}
     * @memberof Pagination
     */
    totalCount: number;
    /**
     *
     * @type {number}
     * @memberof Pagination
     */
    totalPage: number;
    /**
     *
     * @type {number}
     * @memberof Pagination
     */
    currentCount: number;
    /**
     *
     * @type {number}
     * @memberof Pagination
     */
    currentPage: number;
    /**
     *
     * @type {number}
     * @memberof Pagination
     */
    pageSize: number;
    /**
     *
     * @type {boolean}
     * @memberof Pagination
     */
    isLast: boolean;
}
/**
 *
 * @export
 * @interface PasswordAuthenticationResponse
 */
export interface PasswordAuthenticationResponse {
    /**
     *
     * @type {boolean}
     * @memberof PasswordAuthenticationResponse
     */
    isAuthenticate: boolean;
}
/**
 *
 * @export
 * @interface PasswordProtectionDto
 */
export interface PasswordProtectionDto {
    /**
     *
     * @type {string}
     * @memberof PasswordProtectionDto
     */
    resourceType?: string;
    /**
     *
     * @type {number}
     * @memberof PasswordProtectionDto
     */
    resourcePublicId?: number;
    /**
     *
     * @type {string}
     * @memberof PasswordProtectionDto
     */
    password?: string;
}
/**
 *
 * @export
 * @interface Product
 */
export interface Product {
    /**
     *
     * @type {number}
     * @memberof Product
     */
    publicId: number;
    /**
     *
     * @type {number}
     * @memberof Product
     */
    merchantId: number;
    /**
     *
     * @type {number}
     * @memberof Product
     */
    scheme: number;
    /**
     *
     * @type {string}
     * @memberof Product
     */
    name: string;
    /**
     *
     * @type {ProductImageUrl}
     * @memberof Product
     */
    imageUrl: ProductImageUrl;
    /**
     *
     * @type {string}
     * @memberof Product
     */
    description: string;
    /**
     *
     * @type {number}
     * @memberof Product
     */
    price: number;
    /**
     *
     * @type {number}
     * @memberof Product
     */
    ticketCount: number;
    /**
     *
     * @type {number}
     * @memberof Product
     */
    expiration: number;
    /**
     *
     * @type {boolean}
     * @memberof Product
     */
    isPasswordProtected: boolean;
    /**
     *
     * @type {string}
     * @memberof Product
     */
    publishedAt: string;
}
/**
 *
 * @export
 * @interface ProductImageUrl
 */
export interface ProductImageUrl {
    /**
     *
     * @type {string}
     * @memberof ProductImageUrl
     */
    original: string;
    /**
     *
     * @type {string}
     * @memberof ProductImageUrl
     */
    thumbnail: string;
    /**
     *
     * @type {string}
     * @memberof ProductImageUrl
     */
    small: string;
    /**
     *
     * @type {string}
     * @memberof ProductImageUrl
     */
    medium: string;
    /**
     *
     * @type {string}
     * @memberof ProductImageUrl
     */
    large: string;
}
/**
 *
 * @export
 * @interface Rating
 */
export interface Rating {
    /**
     *
     * @type {number}
     * @memberof Rating
     */
    totalCount: number;
    /**
     *
     * @type {number}
     * @memberof Rating
     */
    average: number;
}
/**
 *
 * @export
 * @interface Regulation
 */
export interface Regulation {
    /**
     *
     * @type {ReservableRegulation}
     * @memberof Regulation
     */
    reservableFrom: ReservableRegulation;
    /**
     *
     * @type {ReservableRegulation}
     * @memberof Regulation
     */
    reservableUntil: ReservableRegulation;
    /**
     *
     * @type {CancelableRegulation}
     * @memberof Regulation
     */
    cancelable: CancelableRegulation;
    /**
     *
     * @type {ChangeableRegulation}
     * @memberof Regulation
     */
    changeable: ChangeableRegulation;
}
/**
 *
 * @export
 * @interface ReservableRegulation
 */
export interface ReservableRegulation {
    /**
     *
     * @type {string}
     * @memberof ReservableRegulation
     */
    type: string;
    /**
     *
     * @type {number}
     * @memberof ReservableRegulation
     */
    months: number;
    /**
     *
     * @type {number}
     * @memberof ReservableRegulation
     */
    days: number;
    /**
     *
     * @type {number}
     * @memberof ReservableRegulation
     */
    hours: number;
    /**
     *
     * @type {number}
     * @memberof ReservableRegulation
     */
    minutes: number;
}
/**
 *
 * @export
 * @interface Review
 */
export interface Review {
    /**
     *
     * @type {number}
     * @memberof Review
     */
    id: number;
    /**
     *
     * @type {string}
     * @memberof Review
     */
    name: string;
    /**
     *
     * @type {string}
     * @memberof Review
     */
    gender: string;
    /**
     *
     * @type {string}
     * @memberof Review
     */
    birthday: string;
    /**
     *
     * @type {number}
     * @memberof Review
     */
    rating: number;
    /**
     *
     * @type {string}
     * @memberof Review
     */
    comment: string;
    /**
     *
     * @type {ReviewReply}
     * @memberof Review
     */
    reply: ReviewReply;
    /**
     *
     * @type {string}
     * @memberof Review
     */
    createdAt: string;
    /**
     *
     * @type {string}
     * @memberof Review
     */
    updatedAt: string;
}
/**
 *
 * @export
 * @interface ReviewReply
 */
export interface ReviewReply {
    /**
     *
     * @type {string}
     * @memberof ReviewReply
     */
    comment: string;
    /**
     *
     * @type {string}
     * @memberof ReviewReply
     */
    createdAt: string;
    /**
     *
     * @type {string}
     * @memberof ReviewReply
     */
    updatedAt: string;
}
/**
 *
 * @export
 * @interface SessionResponse
 */
export interface SessionResponse {
    /**
     *
     * @type {string}
     * @memberof SessionResponse
     */
    sessionToken: string;
}
/**
 *
 * @export
 * @interface SingleAreaResponse
 */
export interface SingleAreaResponse {
    /**
     *
     * @type {Area}
     * @memberof SingleAreaResponse
     */
    area: Area;
}
/**
 *
 * @export
 * @interface SingleMerchantCategoryResponse
 */
export interface SingleMerchantCategoryResponse {
    /**
     *
     * @type {MerchantCategory}
     * @memberof SingleMerchantCategoryResponse
     */
    merchantCategory: MerchantCategory;
}
/**
 *
 * @export
 * @interface SingleMerchantResponse
 */
export interface SingleMerchantResponse {
    /**
     *
     * @type {Merchant}
     * @memberof SingleMerchantResponse
     */
    merchant: Merchant;
}
/**
 *
 * @export
 * @interface SingleStationResponse
 */
export interface SingleStationResponse {
    /**
     *
     * @type {Station}
     * @memberof SingleStationResponse
     */
    station: Station;
}
/**
 *
 * @export
 * @interface Staff
 */
export interface Staff {
    /**
     *
     * @type {number}
     * @memberof Staff
     */
    id: number;
    /**
     *
     * @type {number}
     * @memberof Staff
     */
    publicId: number;
    /**
     *
     * @type {string}
     * @memberof Staff
     */
    name: string;
    /**
     *
     * @type {ThumbnailImage}
     * @memberof Staff
     */
    image: ThumbnailImage;
    /**
     *
     * @type {string}
     * @memberof Staff
     */
    description: string;
}
/**
 *
 * @export
 * @interface Station
 */
export interface Station {
    /**
     *
     * @type {number}
     * @memberof Station
     */
    id: number;
    /**
     *
     * @type {number}
     * @memberof Station
     */
    originalStationId: number;
    /**
     *
     * @type {string}
     * @memberof Station
     */
    name: string;
    /**
     *
     * @type {number}
     * @memberof Station
     */
    lineId: number;
    /**
     *
     * @type {Line}
     * @memberof Station
     */
    line: Line;
    /**
     *
     * @type {number}
     * @memberof Station
     */
    prefectureAreaId: number;
    /**
     *
     * @type {Area}
     * @memberof Station
     */
    prefectureArea: Area;
    /**
     *
     * @type {number}
     * @memberof Station
     */
    areaId: number | null;
    /**
     *
     * @type {Area & AnyType}
     * @memberof Station
     */
    area: Area & AnyType;
}
/**
 *
 * @export
 * @interface ThumbnailImage
 */
export interface ThumbnailImage {
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof ThumbnailImage
     */
    original: ThumbnailImageScheme;
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof ThumbnailImage
     */
    square: ThumbnailImageScheme;
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof ThumbnailImage
     */
    c800x420: ThumbnailImageScheme;
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof ThumbnailImage
     */
    p800x600: ThumbnailImageScheme;
    /**
     *
     * @type {ThumbnailImageScheme}
     * @memberof ThumbnailImage
     */
    w1280: ThumbnailImageScheme;
}
/**
 *
 * @export
 * @interface ThumbnailImageScheme
 */
export interface ThumbnailImageScheme {
    /**
     *
     * @type {string}
     * @memberof ThumbnailImageScheme
     */
    url: string;
}
/**
 *
 * @export
 * @interface ThumbnailOriginalImageScheme
 */
export interface ThumbnailOriginalImageScheme {
    /**
     *
     * @type {number}
     * @memberof ThumbnailOriginalImageScheme
     */
    width: number;
    /**
     *
     * @type {number}
     * @memberof ThumbnailOriginalImageScheme
     */
    height: number;
    /**
     *
     * @type {string}
     * @memberof ThumbnailOriginalImageScheme
     */
    url: string;
}
/**
 *
 * @export
 * @interface TimeSlot
 */
export interface TimeSlot {
    /**
     *
     * @type {number}
     * @memberof TimeSlot
     */
    bookingServiceId: number;
    /**
     *
     * @type {number}
     * @memberof TimeSlot
     */
    lessonID: number;
    /**
     *
     * @type {number}
     * @memberof TimeSlot
     */
    capacity: number;
    /**
     *
     * @type {number}
     * @memberof TimeSlot
     */
    accepted: number;
    /**
     *
     * @type {number}
     * @memberof TimeSlot
     */
    pending: number;
    /**
     *
     * @type {string}
     * @memberof TimeSlot
     */
    recurrenceKey: string;
    /**
     *
     * @type {string}
     * @memberof TimeSlot
     */
    startAt: string;
    /**
     *
     * @type {string}
     * @memberof TimeSlot
     */
    endAt: string;
}
/**
 *
 * @export
 * @interface UsecaseMerchantBookingServiceCalenderResponse
 */
export interface UsecaseMerchantBookingServiceCalenderResponse {
    /**
     *
     * @type {Array<BookingServiceCalenderDate>}
     * @memberof UsecaseMerchantBookingServiceCalenderResponse
     */
    calenders: Array<BookingServiceCalenderDate>;
    /**
     *
     * @type {Array<BookingService>}
     * @memberof UsecaseMerchantBookingServiceCalenderResponse
     */
    serviceList: Array<BookingService>;
}
/**
 *
 * @export
 * @interface UsecaseMerchantMultiBlogPostResponse
 */
export interface UsecaseMerchantMultiBlogPostResponse {
    /**
     *
     * @type {Array<BlogPost>}
     * @memberof UsecaseMerchantMultiBlogPostResponse
     */
    blogPosts: Array<BlogPost>;
    /**
     *
     * @type {Pagination}
     * @memberof UsecaseMerchantMultiBlogPostResponse
     */
    pagination: Pagination;
}
/**
 *
 * @export
 * @interface UsecaseMerchantMultiServiceResponse
 */
export interface UsecaseMerchantMultiServiceResponse {
    /**
     *
     * @type {Array<BookingService>}
     * @memberof UsecaseMerchantMultiServiceResponse
     */
    bookingServices: Array<BookingService>;
    /**
     *
     * @type {Pagination}
     * @memberof UsecaseMerchantMultiServiceResponse
     */
    pagination: Pagination;
}
/**
 *
 * @export
 * @interface UsecaseMerchantSingleBlogPostResponse
 */
export interface UsecaseMerchantSingleBlogPostResponse {
    /**
     *
     * @type {BlogPost}
     * @memberof UsecaseMerchantSingleBlogPostResponse
     */
    blogPost: BlogPost;
}
/**
 *
 * @export
 * @interface UsecaseMerchantSingleServiceResponse
 */
export interface UsecaseMerchantSingleServiceResponse {
    /**
     *
     * @type {boolean}
     * @memberof UsecaseMerchantSingleServiceResponse
     */
    isPasswordProtected: boolean;
    /**
     *
     * @type {boolean}
     * @memberof UsecaseMerchantSingleServiceResponse
     */
    isBookable: boolean;
    /**
     *
     * @type {BookingService}
     * @memberof UsecaseMerchantSingleServiceResponse
     */
    bookingService: BookingService;
    /**
     *
     * @type {Array<Review>}
     * @memberof UsecaseMerchantSingleServiceResponse
     */
    reviews: Array<Review>;
    /**
     *
     * @type {Rating}
     * @memberof UsecaseMerchantSingleServiceResponse
     */
    rating: Rating;
    /**
     *
     * @type {Array<Course>}
     * @memberof UsecaseMerchantSingleServiceResponse
     */
    courses: Array<Course>;
    /**
     *
     * @type {Array<Staff>}
     * @memberof UsecaseMerchantSingleServiceResponse
     */
    staff: Array<Staff>;
    /**
     *
     * @type {Regulation}
     * @memberof UsecaseMerchantSingleServiceResponse
     */
    regulation: Regulation;
    /**
     *
     * @type {MapWidget}
     * @memberof UsecaseMerchantSingleServiceResponse
     */
    mapWidget: MapWidget;
}
/**
 *
 * @export
 * @interface UsecaseMerchantTopContentResponse
 */
export interface UsecaseMerchantTopContentResponse {
    /**
     *
     * @type {Array<Review>}
     * @memberof UsecaseMerchantTopContentResponse
     */
    reviews: Array<Review>;
}
/**
 *
 * @export
 * @interface UsecaseMerchantsLayoutResponse
 */
export interface UsecaseMerchantsLayoutResponse {
    /**
     *
     * @type {Merchant}
     * @memberof UsecaseMerchantsLayoutResponse
     */
    merchant: Merchant;
    /**
     *
     * @type {Area & AnyType}
     * @memberof UsecaseMerchantsLayoutResponse
     */
    area: Area & AnyType;
    /**
     *
     * @type {MerchantCategory & AnyType}
     * @memberof UsecaseMerchantsLayoutResponse
     */
    merchantCategory: MerchantCategory & AnyType;
    /**
     *
     * @type {number}
     * @memberof UsecaseMerchantsLayoutResponse
     */
    bookingServiceCount: number;
    /**
     *
     * @type {number}
     * @memberof UsecaseMerchantsLayoutResponse
     */
    productCount: number;
    /**
     *
     * @type {number}
     * @memberof UsecaseMerchantsLayoutResponse
     */
    blogPostCount: number;
}
/**
 *
 * @export
 * @interface UsecaseMerchantsMultiProductResponse
 */
export interface UsecaseMerchantsMultiProductResponse {
    /**
     *
     * @type {Array<Product>}
     * @memberof UsecaseMerchantsMultiProductResponse
     */
    products: Array<Product>;
    /**
     *
     * @type {Pagination}
     * @memberof UsecaseMerchantsMultiProductResponse
     */
    pagination: Pagination;
}
/**
 *
 * @export
 * @interface UsecaseMerchantsReviewResponse
 */
export interface UsecaseMerchantsReviewResponse {
    /**
     *
     * @type {Array<Review>}
     * @memberof UsecaseMerchantsReviewResponse
     */
    reviews: Array<Review>;
    /**
     *
     * @type {Pagination}
     * @memberof UsecaseMerchantsReviewResponse
     */
    pagination: Pagination;
}
/**
 *
 * @export
 * @interface UsecaseMerchantsSingleProductResponse
 */
export interface UsecaseMerchantsSingleProductResponse {
    /**
     *
     * @type {boolean}
     * @memberof UsecaseMerchantsSingleProductResponse
     */
    isPasswordProtected: boolean;
    /**
     *
     * @type {Product}
     * @memberof UsecaseMerchantsSingleProductResponse
     */
    product: Product;
    /**
     *
     * @type {Array<BookingService>}
     * @memberof UsecaseMerchantsSingleProductResponse
     */
    bookingServices: Array<BookingService>;
    /**
     *
     * @type {string}
     * @memberof UsecaseMerchantsSingleProductResponse
     */
    productStatus: string;
}
/**
 *
 * @export
 * @interface ZoomSetting
 */
export interface ZoomSetting {
    /**
     *
     * @type {boolean}
     * @memberof ZoomSetting
     */
    enableAutoCreate: boolean;
}

/**
 * AreasApi - axios parameter creator
 * @export
 */
export const AreasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasFind: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling areasFind.');
            }
            const localVarPath = `/areas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [query]
         * @param {Array<number>} [areaIds]
         * @param {number} [parentAreaId]
         * @param {boolean} [isParent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasList: async (limit?: number, query?: string, areaIds?: Array<number>, parentAreaId?: number, isParent?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/areas`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (areaIds) {
                localVarQueryParameter['areaIds'] = areaIds;
            }

            if (parentAreaId !== undefined) {
                localVarQueryParameter['parentAreaId'] = parentAreaId;
            }

            if (isParent !== undefined) {
                localVarQueryParameter['isParent'] = isParent;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AreasApi - functional programming interface
 * @export
 */
export const AreasApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async areasFind(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleAreaResponse>> {
            const localVarAxiosArgs = await AreasApiAxiosParamCreator(configuration).areasFind(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [query]
         * @param {Array<number>} [areaIds]
         * @param {number} [parentAreaId]
         * @param {boolean} [isParent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async areasList(limit?: number, query?: string, areaIds?: Array<number>, parentAreaId?: number, isParent?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiAreaResponse>> {
            const localVarAxiosArgs = await AreasApiAxiosParamCreator(configuration).areasList(limit, query, areaIds, parentAreaId, isParent, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AreasApi - factory interface
 * @export
 */
export const AreasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasFind(id: number, options?: any): AxiosPromise<SingleAreaResponse> {
            return AreasApiFp(configuration).areasFind(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [query]
         * @param {Array<number>} [areaIds]
         * @param {number} [parentAreaId]
         * @param {boolean} [isParent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasList(limit?: number, query?: string, areaIds?: Array<number>, parentAreaId?: number, isParent?: boolean, options?: any): AxiosPromise<MultiAreaResponse> {
            return AreasApiFp(configuration).areasList(limit, query, areaIds, parentAreaId, isParent, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AreasApi - object-oriented interface
 * @export
 * @class AreasApi
 * @extends {BaseAPI}
 */
export class AreasApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AreasApi
     */
    public areasFind(id: number, options?: any) {
        return AreasApiFp(this.configuration).areasFind(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {number} [limit]
     * @param {string} [query]
     * @param {Array<number>} [areaIds]
     * @param {number} [parentAreaId]
     * @param {boolean} [isParent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AreasApi
     */
    public areasList(limit?: number, query?: string, areaIds?: Array<number>, parentAreaId?: number, isParent?: boolean, options?: any) {
        return AreasApiFp(this.configuration).areasList(limit, query, areaIds, parentAreaId, isParent, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheck: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/healthcheck`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthcheck(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await DefaultApiAxiosParamCreator(configuration).healthcheck(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheck(options?: any): AxiosPromise<void> {
            return DefaultApiFp(configuration).healthcheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public healthcheck(options?: any) {
        return DefaultApiFp(this.configuration).healthcheck(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ExploreAreasApi - axios parameter creator
 * @export
 */
export const ExploreAreasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {number} merchantCategoryId
         * @param {number} [limit]
         * @param {string} [query]
         * @param {Array<number>} [areaIds]
         * @param {number} [parentAreaId]
         * @param {boolean} [isParent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreAreasList: async (merchantCategoryId: number, limit?: number, query?: string, areaIds?: Array<number>, parentAreaId?: number, isParent?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantCategoryId' is not null or undefined
            if (merchantCategoryId === null || merchantCategoryId === undefined) {
                throw new RequiredError('merchantCategoryId','Required parameter merchantCategoryId was null or undefined when calling exploreAreasList.');
            }
            const localVarPath = `/exploreAreas`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (merchantCategoryId !== undefined) {
                localVarQueryParameter['merchantCategoryId'] = merchantCategoryId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (areaIds) {
                localVarQueryParameter['areaIds'] = areaIds;
            }

            if (parentAreaId !== undefined) {
                localVarQueryParameter['parentAreaId'] = parentAreaId;
            }

            if (isParent !== undefined) {
                localVarQueryParameter['isParent'] = isParent;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExploreAreasApi - functional programming interface
 * @export
 */
export const ExploreAreasApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {number} merchantCategoryId
         * @param {number} [limit]
         * @param {string} [query]
         * @param {Array<number>} [areaIds]
         * @param {number} [parentAreaId]
         * @param {boolean} [isParent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exploreAreasList(merchantCategoryId: number, limit?: number, query?: string, areaIds?: Array<number>, parentAreaId?: number, isParent?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiExploreAreaResponse>> {
            const localVarAxiosArgs = await ExploreAreasApiAxiosParamCreator(configuration).exploreAreasList(merchantCategoryId, limit, query, areaIds, parentAreaId, isParent, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExploreAreasApi - factory interface
 * @export
 */
export const ExploreAreasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {number} merchantCategoryId
         * @param {number} [limit]
         * @param {string} [query]
         * @param {Array<number>} [areaIds]
         * @param {number} [parentAreaId]
         * @param {boolean} [isParent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreAreasList(merchantCategoryId: number, limit?: number, query?: string, areaIds?: Array<number>, parentAreaId?: number, isParent?: boolean, options?: any): AxiosPromise<MultiExploreAreaResponse> {
            return ExploreAreasApiFp(configuration).exploreAreasList(merchantCategoryId, limit, query, areaIds, parentAreaId, isParent, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExploreAreasApi - object-oriented interface
 * @export
 * @class ExploreAreasApi
 * @extends {BaseAPI}
 */
export class ExploreAreasApi extends BaseAPI {
    /**
     *
     * @param {number} merchantCategoryId
     * @param {number} [limit]
     * @param {string} [query]
     * @param {Array<number>} [areaIds]
     * @param {number} [parentAreaId]
     * @param {boolean} [isParent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExploreAreasApi
     */
    public exploreAreasList(merchantCategoryId: number, limit?: number, query?: string, areaIds?: Array<number>, parentAreaId?: number, isParent?: boolean, options?: any) {
        return ExploreAreasApiFp(this.configuration).exploreAreasList(merchantCategoryId, limit, query, areaIds, parentAreaId, isParent, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ExploreStationsApi - axios parameter creator
 * @export
 */
export const ExploreStationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {number} merchantCategoryId
         * @param {number} [limit]
         * @param {string} [query]
         * @param {number} [areaId]
         * @param {number} [prefectureAreaId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreStationsList: async (merchantCategoryId: number, limit?: number, query?: string, areaId?: number, prefectureAreaId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantCategoryId' is not null or undefined
            if (merchantCategoryId === null || merchantCategoryId === undefined) {
                throw new RequiredError('merchantCategoryId','Required parameter merchantCategoryId was null or undefined when calling exploreStationsList.');
            }
            const localVarPath = `/exploreStations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (merchantCategoryId !== undefined) {
                localVarQueryParameter['merchantCategoryId'] = merchantCategoryId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (areaId !== undefined) {
                localVarQueryParameter['areaId'] = areaId;
            }

            if (prefectureAreaId !== undefined) {
                localVarQueryParameter['prefectureAreaId'] = prefectureAreaId;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExploreStationsApi - functional programming interface
 * @export
 */
export const ExploreStationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {number} merchantCategoryId
         * @param {number} [limit]
         * @param {string} [query]
         * @param {number} [areaId]
         * @param {number} [prefectureAreaId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exploreStationsList(merchantCategoryId: number, limit?: number, query?: string, areaId?: number, prefectureAreaId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiExploreStationResponse>> {
            const localVarAxiosArgs = await ExploreStationsApiAxiosParamCreator(configuration).exploreStationsList(merchantCategoryId, limit, query, areaId, prefectureAreaId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExploreStationsApi - factory interface
 * @export
 */
export const ExploreStationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {number} merchantCategoryId
         * @param {number} [limit]
         * @param {string} [query]
         * @param {number} [areaId]
         * @param {number} [prefectureAreaId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreStationsList(merchantCategoryId: number, limit?: number, query?: string, areaId?: number, prefectureAreaId?: number, options?: any): AxiosPromise<MultiExploreStationResponse> {
            return ExploreStationsApiFp(configuration).exploreStationsList(merchantCategoryId, limit, query, areaId, prefectureAreaId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExploreStationsApi - object-oriented interface
 * @export
 * @class ExploreStationsApi
 * @extends {BaseAPI}
 */
export class ExploreStationsApi extends BaseAPI {
    /**
     *
     * @param {number} merchantCategoryId
     * @param {number} [limit]
     * @param {string} [query]
     * @param {number} [areaId]
     * @param {number} [prefectureAreaId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExploreStationsApi
     */
    public exploreStationsList(merchantCategoryId: number, limit?: number, query?: string, areaId?: number, prefectureAreaId?: number, options?: any) {
        return ExploreStationsApiFp(this.configuration).exploreStationsList(merchantCategoryId, limit, query, areaId, prefectureAreaId, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ExploresApi - axios parameter creator
 * @export
 */
export const ExploresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {number} categoryId
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreAreasSuggestion: async (categoryId: number, query?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling exploreAreasSuggestion.');
            }
            const localVarPath = `/uc/explore/categories/{categoryId}/areas/suggestion`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [query]
         * @param {Array<number>} [merchantCategoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreCategories: async (query?: string, merchantCategoryIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/uc/explore/categories`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (merchantCategoryIds) {
                localVarQueryParameter['merchantCategoryIds'] = merchantCategoryIds;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} categoryId
         * @param {number} page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreCategoriesById: async (categoryId: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling exploreCategoriesById.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling exploreCategoriesById.');
            }
            const localVarPath = `/uc/explore/categories/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} categoryId
         * @param {number} areaId
         * @param {number} page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreCategoryArea: async (categoryId: number, areaId: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling exploreCategoryArea.');
            }
            // verify required parameter 'areaId' is not null or undefined
            if (areaId === null || areaId === undefined) {
                throw new RequiredError('areaId','Required parameter areaId was null or undefined when calling exploreCategoryArea.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling exploreCategoryArea.');
            }
            const localVarPath = `/uc/explore/categories/{categoryId}/areas/{areaId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)))
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} categoryId
         * @param {number} stationId
         * @param {number} page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreCategoryStation: async (categoryId: number, stationId: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling exploreCategoryStation.');
            }
            // verify required parameter 'stationId' is not null or undefined
            if (stationId === null || stationId === undefined) {
                throw new RequiredError('stationId','Required parameter stationId was null or undefined when calling exploreCategoryStation.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling exploreCategoryStation.');
            }
            const localVarPath = `/uc/explore/categories/{categoryId}/stations/{stationId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)))
                .replace(`{${"stationId"}}`, encodeURIComponent(String(stationId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreTopContent: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/uc/explore`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExploresApi - functional programming interface
 * @export
 */
export const ExploresApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {number} categoryId
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exploreAreasSuggestion(categoryId: number, query?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AreasSuggestionResponse>> {
            const localVarAxiosArgs = await ExploresApiAxiosParamCreator(configuration).exploreAreasSuggestion(categoryId, query, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} [query]
         * @param {Array<number>} [merchantCategoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exploreCategories(query?: string, merchantCategoryIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiMerchantCategoryResponse>> {
            const localVarAxiosArgs = await ExploresApiAxiosParamCreator(configuration).exploreCategories(query, merchantCategoryIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {number} categoryId
         * @param {number} page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exploreCategoriesById(categoryId: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExploreCategoryResponse>> {
            const localVarAxiosArgs = await ExploresApiAxiosParamCreator(configuration).exploreCategoriesById(categoryId, page, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {number} categoryId
         * @param {number} areaId
         * @param {number} page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exploreCategoryArea(categoryId: number, areaId: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExploreCategoryAreaResponse>> {
            const localVarAxiosArgs = await ExploresApiAxiosParamCreator(configuration).exploreCategoryArea(categoryId, areaId, page, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {number} categoryId
         * @param {number} stationId
         * @param {number} page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exploreCategoryStation(categoryId: number, stationId: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExploreCategoryStationResponse>> {
            const localVarAxiosArgs = await ExploresApiAxiosParamCreator(configuration).exploreCategoryStation(categoryId, stationId, page, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exploreTopContent(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExploreTopContentResponse>> {
            const localVarAxiosArgs = await ExploresApiAxiosParamCreator(configuration).exploreTopContent(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExploresApi - factory interface
 * @export
 */
export const ExploresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {number} categoryId
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreAreasSuggestion(categoryId: number, query?: string, options?: any): AxiosPromise<AreasSuggestionResponse> {
            return ExploresApiFp(configuration).exploreAreasSuggestion(categoryId, query, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [query]
         * @param {Array<number>} [merchantCategoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreCategories(query?: string, merchantCategoryIds?: Array<number>, options?: any): AxiosPromise<MultiMerchantCategoryResponse> {
            return ExploresApiFp(configuration).exploreCategories(query, merchantCategoryIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} categoryId
         * @param {number} page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreCategoriesById(categoryId: number, page: number, options?: any): AxiosPromise<ExploreCategoryResponse> {
            return ExploresApiFp(configuration).exploreCategoriesById(categoryId, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} categoryId
         * @param {number} areaId
         * @param {number} page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreCategoryArea(categoryId: number, areaId: number, page: number, options?: any): AxiosPromise<ExploreCategoryAreaResponse> {
            return ExploresApiFp(configuration).exploreCategoryArea(categoryId, areaId, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} categoryId
         * @param {number} stationId
         * @param {number} page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreCategoryStation(categoryId: number, stationId: number, page: number, options?: any): AxiosPromise<ExploreCategoryStationResponse> {
            return ExploresApiFp(configuration).exploreCategoryStation(categoryId, stationId, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreTopContent(options?: any): AxiosPromise<ExploreTopContentResponse> {
            return ExploresApiFp(configuration).exploreTopContent(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExploresApi - object-oriented interface
 * @export
 * @class ExploresApi
 * @extends {BaseAPI}
 */
export class ExploresApi extends BaseAPI {
    /**
     *
     * @param {number} categoryId
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExploresApi
     */
    public exploreAreasSuggestion(categoryId: number, query?: string, options?: any) {
        return ExploresApiFp(this.configuration).exploreAreasSuggestion(categoryId, query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} [query]
     * @param {Array<number>} [merchantCategoryIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExploresApi
     */
    public exploreCategories(query?: string, merchantCategoryIds?: Array<number>, options?: any) {
        return ExploresApiFp(this.configuration).exploreCategories(query, merchantCategoryIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {number} categoryId
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExploresApi
     */
    public exploreCategoriesById(categoryId: number, page: number, options?: any) {
        return ExploresApiFp(this.configuration).exploreCategoriesById(categoryId, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {number} categoryId
     * @param {number} areaId
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExploresApi
     */
    public exploreCategoryArea(categoryId: number, areaId: number, page: number, options?: any) {
        return ExploresApiFp(this.configuration).exploreCategoryArea(categoryId, areaId, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {number} categoryId
     * @param {number} stationId
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExploresApi
     */
    public exploreCategoryStation(categoryId: number, stationId: number, page: number, options?: any) {
        return ExploresApiFp(this.configuration).exploreCategoryStation(categoryId, stationId, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExploresApi
     */
    public exploreTopContent(options?: any) {
        return ExploresApiFp(this.configuration).exploreTopContent(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * IosApi - axios parameter creator
 * @export
 */
export const IosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} xAppVersion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iosAvailable: async (xAppVersion: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xAppVersion' is not null or undefined
            if (xAppVersion === null || xAppVersion === undefined) {
                throw new RequiredError('xAppVersion','Required parameter xAppVersion was null or undefined when calling iosAvailable.');
            }
            const localVarPath = `/ios/available`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xAppVersion !== undefined && xAppVersion !== null) {
                localVarHeaderParameter['x-app-version'] = String(xAppVersion);
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IosApi - functional programming interface
 * @export
 */
export const IosApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} xAppVersion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async iosAvailable(xAppVersion: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableResponse>> {
            const localVarAxiosArgs = await IosApiAxiosParamCreator(configuration).iosAvailable(xAppVersion, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * IosApi - factory interface
 * @export
 */
export const IosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {string} xAppVersion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iosAvailable(xAppVersion: string, options?: any): AxiosPromise<AvailableResponse> {
            return IosApiFp(configuration).iosAvailable(xAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IosApi - object-oriented interface
 * @export
 * @class IosApi
 * @extends {BaseAPI}
 */
export class IosApi extends BaseAPI {
    /**
     *
     * @param {string} xAppVersion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IosApi
     */
    public iosAvailable(xAppVersion: string, options?: any) {
        return IosApiFp(this.configuration).iosAvailable(xAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * MerchantCategoriesApi - axios parameter creator
 * @export
 */
export const MerchantCategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantCategoriesFind: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling merchantCategoriesFind.');
            }
            const localVarPath = `/merchant_categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [query]
         * @param {Array<number>} [merchantCategoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantCategoriesList: async (query?: string, merchantCategoryIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/merchant_categories`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (merchantCategoryIds) {
                localVarQueryParameter['merchantCategoryIds'] = merchantCategoryIds;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantCategoriesApi - functional programming interface
 * @export
 */
export const MerchantCategoriesApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantCategoriesFind(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleMerchantCategoryResponse>> {
            const localVarAxiosArgs = await MerchantCategoriesApiAxiosParamCreator(configuration).merchantCategoriesFind(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} [query]
         * @param {Array<number>} [merchantCategoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantCategoriesList(query?: string, merchantCategoryIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiMerchantCategoryResponse>> {
            const localVarAxiosArgs = await MerchantCategoriesApiAxiosParamCreator(configuration).merchantCategoriesList(query, merchantCategoryIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MerchantCategoriesApi - factory interface
 * @export
 */
export const MerchantCategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantCategoriesFind(id: number, options?: any): AxiosPromise<SingleMerchantCategoryResponse> {
            return MerchantCategoriesApiFp(configuration).merchantCategoriesFind(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [query]
         * @param {Array<number>} [merchantCategoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantCategoriesList(query?: string, merchantCategoryIds?: Array<number>, options?: any): AxiosPromise<MultiMerchantCategoryResponse> {
            return MerchantCategoriesApiFp(configuration).merchantCategoriesList(query, merchantCategoryIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MerchantCategoriesApi - object-oriented interface
 * @export
 * @class MerchantCategoriesApi
 * @extends {BaseAPI}
 */
export class MerchantCategoriesApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCategoriesApi
     */
    public merchantCategoriesFind(id: number, options?: any) {
        return MerchantCategoriesApiFp(this.configuration).merchantCategoriesFind(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} [query]
     * @param {Array<number>} [merchantCategoryIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCategoriesApi
     */
    public merchantCategoriesList(query?: string, merchantCategoryIds?: Array<number>, options?: any) {
        return MerchantCategoriesApiFp(this.configuration).merchantCategoriesList(query, merchantCategoryIds, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * MerchantsApi - axios parameter creator
 * @export
 */
export const MerchantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} publicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsFind: async (publicId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId','Required parameter publicId was null or undefined when calling merchantsFind.');
            }
            const localVarPath = `/merchants/{publicId}`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [orderBy]
         * @param {string} [orderType]
         * @param {string} [query]
         * @param {number} [merchantCategoryId]
         * @param {number} [areaId]
         * @param {number} [stationId]
         * @param {boolean} [isSubscribed]
         * @param {boolean} [isPublic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsList: async (limit?: number, page?: number, orderBy?: string, orderType?: string, query?: string, merchantCategoryId?: number, areaId?: number, stationId?: number, isSubscribed?: boolean, isPublic?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/merchants`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderType !== undefined) {
                localVarQueryParameter['orderType'] = orderType;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (merchantCategoryId !== undefined) {
                localVarQueryParameter['merchantCategoryId'] = merchantCategoryId;
            }

            if (areaId !== undefined) {
                localVarQueryParameter['areaId'] = areaId;
            }

            if (stationId !== undefined) {
                localVarQueryParameter['stationId'] = stationId;
            }

            if (isSubscribed !== undefined) {
                localVarQueryParameter['isSubscribed'] = isSubscribed;
            }

            if (isPublic !== undefined) {
                localVarQueryParameter['isPublic'] = isPublic;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantsApi - functional programming interface
 * @export
 */
export const MerchantsApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} publicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantsFind(publicId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleMerchantResponse>> {
            const localVarAxiosArgs = await MerchantsApiAxiosParamCreator(configuration).merchantsFind(publicId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [orderBy]
         * @param {string} [orderType]
         * @param {string} [query]
         * @param {number} [merchantCategoryId]
         * @param {number} [areaId]
         * @param {number} [stationId]
         * @param {boolean} [isSubscribed]
         * @param {boolean} [isPublic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantsList(limit?: number, page?: number, orderBy?: string, orderType?: string, query?: string, merchantCategoryId?: number, areaId?: number, stationId?: number, isSubscribed?: boolean, isPublic?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiMerchantResponse>> {
            const localVarAxiosArgs = await MerchantsApiAxiosParamCreator(configuration).merchantsList(limit, page, orderBy, orderType, query, merchantCategoryId, areaId, stationId, isSubscribed, isPublic, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MerchantsApi - factory interface
 * @export
 */
export const MerchantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {string} publicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsFind(publicId: string, options?: any): AxiosPromise<SingleMerchantResponse> {
            return MerchantsApiFp(configuration).merchantsFind(publicId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [orderBy]
         * @param {string} [orderType]
         * @param {string} [query]
         * @param {number} [merchantCategoryId]
         * @param {number} [areaId]
         * @param {number} [stationId]
         * @param {boolean} [isSubscribed]
         * @param {boolean} [isPublic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsList(limit?: number, page?: number, orderBy?: string, orderType?: string, query?: string, merchantCategoryId?: number, areaId?: number, stationId?: number, isSubscribed?: boolean, isPublic?: boolean, options?: any): AxiosPromise<MultiMerchantResponse> {
            return MerchantsApiFp(configuration).merchantsList(limit, page, orderBy, orderType, query, merchantCategoryId, areaId, stationId, isSubscribed, isPublic, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MerchantsApi - object-oriented interface
 * @export
 * @class MerchantsApi
 * @extends {BaseAPI}
 */
export class MerchantsApi extends BaseAPI {
    /**
     *
     * @param {string} publicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public merchantsFind(publicId: string, options?: any) {
        return MerchantsApiFp(this.configuration).merchantsFind(publicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {number} [limit]
     * @param {number} [page]
     * @param {string} [orderBy]
     * @param {string} [orderType]
     * @param {string} [query]
     * @param {number} [merchantCategoryId]
     * @param {number} [areaId]
     * @param {number} [stationId]
     * @param {boolean} [isSubscribed]
     * @param {boolean} [isPublic]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public merchantsList(limit?: number, page?: number, orderBy?: string, orderType?: string, query?: string, merchantCategoryId?: number, areaId?: number, stationId?: number, isSubscribed?: boolean, isPublic?: boolean, options?: any) {
        return MerchantsApiFp(this.configuration).merchantsList(limit, page, orderBy, orderType, query, merchantCategoryId, areaId, stationId, isSubscribed, isPublic, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * PasswordProtectionsApi - axios parameter creator
 * @export
 */
export const PasswordProtectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {PasswordProtectionDto} passwordProtectionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordAuthetication: async (passwordProtectionDto: PasswordProtectionDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordProtectionDto' is not null or undefined
            if (passwordProtectionDto === null || passwordProtectionDto === undefined) {
                throw new RequiredError('passwordProtectionDto','Required parameter passwordProtectionDto was null or undefined when calling passwordAuthetication.');
            }
            const localVarPath = `/password_protections`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof passwordProtectionDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(passwordProtectionDto !== undefined ? passwordProtectionDto : {}) : (passwordProtectionDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PasswordProtectionsApi - functional programming interface
 * @export
 */
export const PasswordProtectionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {PasswordProtectionDto} passwordProtectionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordAuthetication(passwordProtectionDto: PasswordProtectionDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordAuthenticationResponse>> {
            const localVarAxiosArgs = await PasswordProtectionsApiAxiosParamCreator(configuration).passwordAuthetication(passwordProtectionDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PasswordProtectionsApi - factory interface
 * @export
 */
export const PasswordProtectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {PasswordProtectionDto} passwordProtectionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordAuthetication(passwordProtectionDto: PasswordProtectionDto, options?: any): AxiosPromise<PasswordAuthenticationResponse> {
            return PasswordProtectionsApiFp(configuration).passwordAuthetication(passwordProtectionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PasswordProtectionsApi - object-oriented interface
 * @export
 * @class PasswordProtectionsApi
 * @extends {BaseAPI}
 */
export class PasswordProtectionsApi extends BaseAPI {
    /**
     *
     * @param {PasswordProtectionDto} passwordProtectionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordProtectionsApi
     */
    public passwordAuthetication(passwordProtectionDto: PasswordProtectionDto, options?: any) {
        return PasswordProtectionsApiFp(this.configuration).passwordAuthetication(passwordProtectionDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SessionsApi - axios parameter creator
 * @export
 */
export const SessionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSession: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/session`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionsApi - functional programming interface
 * @export
 */
export const SessionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSession(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionResponse>> {
            const localVarAxiosArgs = await SessionsApiAxiosParamCreator(configuration).createSession(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SessionsApi - factory interface
 * @export
 */
export const SessionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSession(options?: any): AxiosPromise<SessionResponse> {
            return SessionsApiFp(configuration).createSession(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionsApi - object-oriented interface
 * @export
 * @class SessionsApi
 * @extends {BaseAPI}
 */
export class SessionsApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public createSession(options?: any) {
        return SessionsApiFp(this.configuration).createSession(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * StationsApi - axios parameter creator
 * @export
 */
export const StationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsFind: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling stationsFind.');
            }
            const localVarPath = `/stations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [query]
         * @param {number} [areaId]
         * @param {number} [prefectureAreaId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsList: async (limit?: number, query?: string, areaId?: number, prefectureAreaId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/stations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (areaId !== undefined) {
                localVarQueryParameter['areaId'] = areaId;
            }

            if (prefectureAreaId !== undefined) {
                localVarQueryParameter['prefectureAreaId'] = prefectureAreaId;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StationsApi - functional programming interface
 * @export
 */
export const StationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stationsFind(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleStationResponse>> {
            const localVarAxiosArgs = await StationsApiAxiosParamCreator(configuration).stationsFind(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [query]
         * @param {number} [areaId]
         * @param {number} [prefectureAreaId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stationsList(limit?: number, query?: string, areaId?: number, prefectureAreaId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiStationResponse>> {
            const localVarAxiosArgs = await StationsApiAxiosParamCreator(configuration).stationsList(limit, query, areaId, prefectureAreaId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StationsApi - factory interface
 * @export
 */
export const StationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsFind(id: number, options?: any): AxiosPromise<SingleStationResponse> {
            return StationsApiFp(configuration).stationsFind(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [query]
         * @param {number} [areaId]
         * @param {number} [prefectureAreaId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsList(limit?: number, query?: string, areaId?: number, prefectureAreaId?: number, options?: any): AxiosPromise<MultiStationResponse> {
            return StationsApiFp(configuration).stationsList(limit, query, areaId, prefectureAreaId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StationsApi - object-oriented interface
 * @export
 * @class StationsApi
 * @extends {BaseAPI}
 */
export class StationsApi extends BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    public stationsFind(id: number, options?: any) {
        return StationsApiFp(this.configuration).stationsFind(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {number} [limit]
     * @param {string} [query]
     * @param {number} [areaId]
     * @param {number} [prefectureAreaId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    public stationsList(limit?: number, query?: string, areaId?: number, prefectureAreaId?: number, options?: any) {
        return StationsApiFp(this.configuration).stationsList(limit, query, areaId, prefectureAreaId, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * UcMerchantsApi - axios parameter creator
 * @export
 */
export const UcMerchantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} publicId
         * @param {number} blogId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsBlog: async (publicId: string, blogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId','Required parameter publicId was null or undefined when calling merchantsBlog.');
            }
            // verify required parameter 'blogId' is not null or undefined
            if (blogId === null || blogId === undefined) {
                throw new RequiredError('blogId','Required parameter blogId was null or undefined when calling merchantsBlog.');
            }
            const localVarPath = `/uc/merchants/{publicId}/blogs/{blogId}`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)))
                .replace(`{${"blogId"}}`, encodeURIComponent(String(blogId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [query]
         * @param {boolean} [isPublished]
         * @param {string} [orderBy]
         * @param {string} [orderType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsBlogs: async (publicId: string, page?: number, limit?: number, query?: string, isPublished?: boolean, orderBy?: string, orderType?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId','Required parameter publicId was null or undefined when calling merchantsBlogs.');
            }
            const localVarPath = `/uc/merchants/{publicId}/blogs`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (isPublished !== undefined) {
                localVarQueryParameter['isPublished'] = isPublished;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderType !== undefined) {
                localVarQueryParameter['orderType'] = orderType;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsCalender: async (publicId: string, startDate: string, endDate: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId','Required parameter publicId was null or undefined when calling merchantsCalender.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new RequiredError('startDate','Required parameter startDate was null or undefined when calling merchantsCalender.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new RequiredError('endDate','Required parameter endDate was null or undefined when calling merchantsCalender.');
            }
            const localVarPath = `/uc/merchants/{publicId}/calender`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsLayout: async (publicId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId','Required parameter publicId was null or undefined when calling merchantsLayout.');
            }
            const localVarPath = `/uc/merchants/{publicId}/layout`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {number} productPublicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsProduct: async (publicId: string, productPublicId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId','Required parameter publicId was null or undefined when calling merchantsProduct.');
            }
            // verify required parameter 'productPublicId' is not null or undefined
            if (productPublicId === null || productPublicId === undefined) {
                throw new RequiredError('productPublicId','Required parameter productPublicId was null or undefined when calling merchantsProduct.');
            }
            const localVarPath = `/uc/merchants/{publicId}/products/{productPublicId}`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)))
                .replace(`{${"productPublicId"}}`, encodeURIComponent(String(productPublicId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [query]
         * @param {boolean} [isPublished]
         * @param {boolean} [isListable]
         * @param {string} [orderBy]
         * @param {string} [orderType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsProducts: async (publicId: string, page?: number, limit?: number, query?: string, isPublished?: boolean, isListable?: boolean, orderBy?: string, orderType?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId','Required parameter publicId was null or undefined when calling merchantsProducts.');
            }
            const localVarPath = `/uc/merchants/{publicId}/products`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (isPublished !== undefined) {
                localVarQueryParameter['isPublished'] = isPublished;
            }

            if (isListable !== undefined) {
                localVarQueryParameter['isListable'] = isListable;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderType !== undefined) {
                localVarQueryParameter['orderType'] = orderType;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsReview: async (publicId: string, page?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId','Required parameter publicId was null or undefined when calling merchantsReview.');
            }
            const localVarPath = `/uc/merchants/{publicId}/review`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {number} servicePublicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsService: async (publicId: string, servicePublicId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId','Required parameter publicId was null or undefined when calling merchantsService.');
            }
            // verify required parameter 'servicePublicId' is not null or undefined
            if (servicePublicId === null || servicePublicId === undefined) {
                throw new RequiredError('servicePublicId','Required parameter servicePublicId was null or undefined when calling merchantsService.');
            }
            const localVarPath = `/uc/merchants/{publicId}/services/{servicePublicId}`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)))
                .replace(`{${"servicePublicId"}}`, encodeURIComponent(String(servicePublicId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {boolean} [isPublished]
         * @param {boolean} [isListable]
         * @param {boolean} [isOrdered]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsServices: async (publicId: string, page?: number, limit?: number, isPublished?: boolean, isListable?: boolean, isOrdered?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId','Required parameter publicId was null or undefined when calling merchantsServices.');
            }
            const localVarPath = `/uc/merchants/{publicId}/services`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (isPublished !== undefined) {
                localVarQueryParameter['isPublished'] = isPublished;
            }

            if (isListable !== undefined) {
                localVarQueryParameter['isListable'] = isListable;
            }

            if (isOrdered !== undefined) {
                localVarQueryParameter['isOrdered'] = isOrdered;
            }



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsTopContent: async (publicId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId','Required parameter publicId was null or undefined when calling merchantsTopContent.');
            }
            const localVarPath = `/uc/merchants/{publicId}`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UcMerchantsApi - functional programming interface
 * @export
 */
export const UcMerchantsApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} publicId
         * @param {number} blogId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantsBlog(publicId: string, blogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsecaseMerchantSingleBlogPostResponse>> {
            const localVarAxiosArgs = await UcMerchantsApiAxiosParamCreator(configuration).merchantsBlog(publicId, blogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [query]
         * @param {boolean} [isPublished]
         * @param {string} [orderBy]
         * @param {string} [orderType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantsBlogs(publicId: string, page?: number, limit?: number, query?: string, isPublished?: boolean, orderBy?: string, orderType?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsecaseMerchantMultiBlogPostResponse>> {
            const localVarAxiosArgs = await UcMerchantsApiAxiosParamCreator(configuration).merchantsBlogs(publicId, page, limit, query, isPublished, orderBy, orderType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantsCalender(publicId: string, startDate: string, endDate: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsecaseMerchantBookingServiceCalenderResponse>> {
            const localVarAxiosArgs = await UcMerchantsApiAxiosParamCreator(configuration).merchantsCalender(publicId, startDate, endDate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantsLayout(publicId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsecaseMerchantsLayoutResponse>> {
            const localVarAxiosArgs = await UcMerchantsApiAxiosParamCreator(configuration).merchantsLayout(publicId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {number} productPublicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantsProduct(publicId: string, productPublicId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsecaseMerchantsSingleProductResponse>> {
            const localVarAxiosArgs = await UcMerchantsApiAxiosParamCreator(configuration).merchantsProduct(publicId, productPublicId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [query]
         * @param {boolean} [isPublished]
         * @param {boolean} [isListable]
         * @param {string} [orderBy]
         * @param {string} [orderType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantsProducts(publicId: string, page?: number, limit?: number, query?: string, isPublished?: boolean, isListable?: boolean, orderBy?: string, orderType?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsecaseMerchantsMultiProductResponse>> {
            const localVarAxiosArgs = await UcMerchantsApiAxiosParamCreator(configuration).merchantsProducts(publicId, page, limit, query, isPublished, isListable, orderBy, orderType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantsReview(publicId: string, page?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsecaseMerchantsReviewResponse>> {
            const localVarAxiosArgs = await UcMerchantsApiAxiosParamCreator(configuration).merchantsReview(publicId, page, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {number} servicePublicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantsService(publicId: string, servicePublicId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsecaseMerchantSingleServiceResponse>> {
            const localVarAxiosArgs = await UcMerchantsApiAxiosParamCreator(configuration).merchantsService(publicId, servicePublicId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {boolean} [isPublished]
         * @param {boolean} [isListable]
         * @param {boolean} [isOrdered]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantsServices(publicId: string, page?: number, limit?: number, isPublished?: boolean, isListable?: boolean, isOrdered?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsecaseMerchantMultiServiceResponse>> {
            const localVarAxiosArgs = await UcMerchantsApiAxiosParamCreator(configuration).merchantsServices(publicId, page, limit, isPublished, isListable, isOrdered, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} publicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantsTopContent(publicId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsecaseMerchantTopContentResponse>> {
            const localVarAxiosArgs = await UcMerchantsApiAxiosParamCreator(configuration).merchantsTopContent(publicId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UcMerchantsApi - factory interface
 * @export
 */
export const UcMerchantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {string} publicId
         * @param {number} blogId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsBlog(publicId: string, blogId: number, options?: any): AxiosPromise<UsecaseMerchantSingleBlogPostResponse> {
            return UcMerchantsApiFp(configuration).merchantsBlog(publicId, blogId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} publicId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [query]
         * @param {boolean} [isPublished]
         * @param {string} [orderBy]
         * @param {string} [orderType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsBlogs(publicId: string, page?: number, limit?: number, query?: string, isPublished?: boolean, orderBy?: string, orderType?: string, options?: any): AxiosPromise<UsecaseMerchantMultiBlogPostResponse> {
            return UcMerchantsApiFp(configuration).merchantsBlogs(publicId, page, limit, query, isPublished, orderBy, orderType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} publicId
         * @param {string} startDate
         * @param {string} endDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsCalender(publicId: string, startDate: string, endDate: string, options?: any): AxiosPromise<UsecaseMerchantBookingServiceCalenderResponse> {
            return UcMerchantsApiFp(configuration).merchantsCalender(publicId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} publicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsLayout(publicId: string, options?: any): AxiosPromise<UsecaseMerchantsLayoutResponse> {
            return UcMerchantsApiFp(configuration).merchantsLayout(publicId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} publicId
         * @param {number} productPublicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsProduct(publicId: string, productPublicId: number, options?: any): AxiosPromise<UsecaseMerchantsSingleProductResponse> {
            return UcMerchantsApiFp(configuration).merchantsProduct(publicId, productPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} publicId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [query]
         * @param {boolean} [isPublished]
         * @param {boolean} [isListable]
         * @param {string} [orderBy]
         * @param {string} [orderType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsProducts(publicId: string, page?: number, limit?: number, query?: string, isPublished?: boolean, isListable?: boolean, orderBy?: string, orderType?: string, options?: any): AxiosPromise<UsecaseMerchantsMultiProductResponse> {
            return UcMerchantsApiFp(configuration).merchantsProducts(publicId, page, limit, query, isPublished, isListable, orderBy, orderType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} publicId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsReview(publicId: string, page?: number, limit?: number, options?: any): AxiosPromise<UsecaseMerchantsReviewResponse> {
            return UcMerchantsApiFp(configuration).merchantsReview(publicId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} publicId
         * @param {number} servicePublicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsService(publicId: string, servicePublicId: number, options?: any): AxiosPromise<UsecaseMerchantSingleServiceResponse> {
            return UcMerchantsApiFp(configuration).merchantsService(publicId, servicePublicId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} publicId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {boolean} [isPublished]
         * @param {boolean} [isListable]
         * @param {boolean} [isOrdered]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsServices(publicId: string, page?: number, limit?: number, isPublished?: boolean, isListable?: boolean, isOrdered?: boolean, options?: any): AxiosPromise<UsecaseMerchantMultiServiceResponse> {
            return UcMerchantsApiFp(configuration).merchantsServices(publicId, page, limit, isPublished, isListable, isOrdered, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} publicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantsTopContent(publicId: string, options?: any): AxiosPromise<UsecaseMerchantTopContentResponse> {
            return UcMerchantsApiFp(configuration).merchantsTopContent(publicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UcMerchantsApi - object-oriented interface
 * @export
 * @class UcMerchantsApi
 * @extends {BaseAPI}
 */
export class UcMerchantsApi extends BaseAPI {
    /**
     *
     * @param {string} publicId
     * @param {number} blogId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UcMerchantsApi
     */
    public merchantsBlog(publicId: string, blogId: number, options?: any) {
        return UcMerchantsApiFp(this.configuration).merchantsBlog(publicId, blogId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} publicId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [query]
     * @param {boolean} [isPublished]
     * @param {string} [orderBy]
     * @param {string} [orderType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UcMerchantsApi
     */
    public merchantsBlogs(publicId: string, page?: number, limit?: number, query?: string, isPublished?: boolean, orderBy?: string, orderType?: string, options?: any) {
        return UcMerchantsApiFp(this.configuration).merchantsBlogs(publicId, page, limit, query, isPublished, orderBy, orderType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} publicId
     * @param {string} startDate
     * @param {string} endDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UcMerchantsApi
     */
    public merchantsCalender(publicId: string, startDate: string, endDate: string, options?: any) {
        return UcMerchantsApiFp(this.configuration).merchantsCalender(publicId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} publicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UcMerchantsApi
     */
    public merchantsLayout(publicId: string, options?: any) {
        return UcMerchantsApiFp(this.configuration).merchantsLayout(publicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} publicId
     * @param {number} productPublicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UcMerchantsApi
     */
    public merchantsProduct(publicId: string, productPublicId: number, options?: any) {
        return UcMerchantsApiFp(this.configuration).merchantsProduct(publicId, productPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} publicId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [query]
     * @param {boolean} [isPublished]
     * @param {boolean} [isListable]
     * @param {string} [orderBy]
     * @param {string} [orderType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UcMerchantsApi
     */
    public merchantsProducts(publicId: string, page?: number, limit?: number, query?: string, isPublished?: boolean, isListable?: boolean, orderBy?: string, orderType?: string, options?: any) {
        return UcMerchantsApiFp(this.configuration).merchantsProducts(publicId, page, limit, query, isPublished, isListable, orderBy, orderType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} publicId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UcMerchantsApi
     */
    public merchantsReview(publicId: string, page?: number, limit?: number, options?: any) {
        return UcMerchantsApiFp(this.configuration).merchantsReview(publicId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} publicId
     * @param {number} servicePublicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UcMerchantsApi
     */
    public merchantsService(publicId: string, servicePublicId: number, options?: any) {
        return UcMerchantsApiFp(this.configuration).merchantsService(publicId, servicePublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} publicId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {boolean} [isPublished]
     * @param {boolean} [isListable]
     * @param {boolean} [isOrdered]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UcMerchantsApi
     */
    public merchantsServices(publicId: string, page?: number, limit?: number, isPublished?: boolean, isListable?: boolean, isOrdered?: boolean, options?: any) {
        return UcMerchantsApiFp(this.configuration).merchantsServices(publicId, page, limit, isPublished, isListable, isOrdered, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} publicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UcMerchantsApi
     */
    public merchantsTopContent(publicId: string, options?: any) {
        return UcMerchantsApiFp(this.configuration).merchantsTopContent(publicId, options).then((request) => request(this.axios, this.basePath));
    }

}


